import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import MobileBottomBar from '../../components/feature/MobileBottomBar';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import PlansSection from './components/PlansSection';
import ProcessSection from './components/ProcessSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="pb-20 md:pb-0">
        <HeroSection />
        <FeaturesSection />
        <PlansSection />
        <ProcessSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
      <MobileBottomBar />
    </div>
  );
}
